import { IPatientInfo } from 'apis/admin/type';
import { SurveyFormProps } from 'components/MuiDialog/SurveyForm';
import {
  initialECardex,
  initialTakingOver,
  initialOutHospitalSurvey,
  initialHospitalizationSurvey,
  initialMedicationSurvey,
  initialRadiology,
  initialPathology,
  initialBedScore,
  initialFall,
  initialPediatric_fall,
  initialGCS,
  initialPediatric_GCS,
  initialFourScore,
  initialSafety,
  initialNeeds,
  initialClinicalObservation,
  initialGlucose,
  initialNRS,
  initialFLACC,
  initialCNPS,
  initialFFI,
  initialKOOS,
  initialLEFS,
  initialSTarTBack,
  initialNDI,
  initialMentalNursing,
  initialBDI,
  initialBAI,
  initialMMSE,
  initialOperation,
  initialAnesthesia,
  initialTransfusion,
  initialDialysis,
  initialEmergency,
  initialChildbirth,
  initialHomeCare,
  initialDietNutrition,
  initialFallPrevention,
  initialPatientGuide,
  initialColonoscopy,
  initialTransfusionAgreement,
  initialNonSalary,
  initialAdmissionCheckList,
  initialDNR,
  initialCoreNursingSkillVideo,
  initialIntakeOutput,
  initialClinicalObservationICU,
  initialIntubation,
  initialCPR,
  initialHospitalConfirm,
  initialCRRT,
  initialIntubationAgree,
  initialCentralVenous,
  initialSuppressor,
  initialSBAR,
} from './initialStates';

export enum MENU {
  E_CARDEX = 'e-CARDEX',
  SBAR1 = 'SBAR 1',
  TAKING_OVER = 'Y tá phụ trách',
  HOSPITALIZATION = 'Hồ sơ bệnh án nội trú',
  OUT_HOSPITAL = 'Hồ sơ xuất viện',
  PRESCRIPTION = 'Lịch sử kê đơn',
  NURSE = 'Hồ sơ điều dưỡng',
  MEDICATION = 'Hồ sơ sử dụng thuốc',
  RADIOLOGY = 'Hồ sơ chẩn đoán hình ảnh',
  PATHOLOGY = 'Bệnh lý lâm sàng',
  CLINICAL_OBSERVATION = 'Chỉ số sinh\ntồn VS',
  CLINICAL_OBSERVATION_ICU = 'Theo dõi lâm sàng (ICU)',
  IORECORD = 'I/O',
  GLUCOSE = 'Đường\nhuyết',
  BEDSORES = 'Thang đo Braden',
  NEEDS = 'Đánh giá\nnhu cầu',
  FALL = 'Thang điểm đo nguy cơ\nté ngã Mouse',
  FALLSCALE = 'Thang điểm nguy cơ té\nngã Humpty Dumpty',
  GCS = 'Thang điểm\nGCS',
  Pediatric_GCS = 'Thang điểm GCS trẻ em',
  FourScore = 'Thang điểm FOUR',
  SAFETY = 'Báo cáo an toàn người bệnh',
  PAIN = 'Đánh giá\nđiểm đau',
  NRS = 'Thang đo\nNRS',
  FLACC = 'Thang đo\nFLACC',
  CNPS = 'CNPS',
  FFI = 'FFI',
  KOOS = 'KOOS',
  LEFS = 'LEFS',
  NDI = 'NDI',
  STarT_BacknScreening = 'Sàng lọc\nSTaT-Back',
  MENTAL_NURSING = 'Hồ sơ sức khỏe tâm\nthần',
  BDI = 'BDI',
  BAI = 'BAI',
  MMSE = 'MMSE',
  COGNITIVE_FUNCTION = '인지기능검사',
  OPERATION = 'Phẫu thuật',
  ANESTHESIA = 'Gây mê',
  TRANSFUSION = 'Truyền máu',
  INTUBATION = 'Đặt nội\nkhí quản',
  CPR = 'CPR',
  DIALYSIS = 'Lọc máu',
  EMERGENCY = 'Cấp cứu',
  CHILDBIRTH = 'Sinh sản',
  HOME_CARE = 'Chăm sóc\ntại nhà',
  DIET_NUTRITION = 'Dinh dưỡng\nvà chế độ ăn',
  PATIENTSGUIDE = 'Hướng dẫn\nbệnh nhân',
  PATIENTCONSENTFORM = 'Biểu mẫu chấp\nthuận của\nbệnh nhân',
  TRANSFUSION_AGREE = 'Truyền máu ',
  CONSCIOUS = 'An thần\ncó ý thức',
  DNR = 'DNR',
  ADMISSION = 'Thoả thuận đồng ý nhập viện',
  ADMISSIONGUIDE = 'Hướng dẫn nhập viện',
  ADMISSION_CHECKLIST = 'Danh sách kiểm tra\nnhập viện',
  FALL_PREVENTION = 'Phòng ngừa\nté ngã',
  CRRT_AGREEMENT = 'CRRT',
  CENTRALVENOUS = 'Đặt CVC',
  INTUBATIONAGREEMENT = 'ETI',
  SUPPRESSOR = 'Sự kiềm chế bằng phương pháp vật lý',
  DRUGCALCULATOR = 'Công cụ tính toán liều lượng thuốc',
  CORE_NURSING_SKILL_VIDEO = 'Tải video lên',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE = 'Screen Settings',
  PATIENT_LABEL_PRINTING = 'in nhãn bệnh nhân',
}

export enum RECORD_TYPE {
  NANDA = '0',
  SOAPIE = '1',
  FOCUS_DAR = '2',
  NARRATIVE_RECORD = '3',
  REMARKS = '4',
}

export interface SurveyDialogProps<T>
  extends Omit<SurveyFormProps, 'children'> {
  user_id: number;
  nurseName: string;
  patientInfo: IPatientInfo;
  disabled?: boolean;
  defaultValues: T;
}

export type TECardexDefaultValues = typeof initialECardex;
export type TSBARDefaultValues = typeof initialSBAR;
export type TTakingOverDefaultValues = typeof initialTakingOver;
export type THospitalizationDefaultValues = typeof initialHospitalizationSurvey;
export type TOutHospitalDefaultValues = typeof initialOutHospitalSurvey;
export type TMedicationDefaultValues = typeof initialMedicationSurvey;
export type TRadiologyDefaultValues = typeof initialRadiology;
export type TPathologyDefaultValues = typeof initialPathology;
export type TClinicalObservationDefaultValues =
  typeof initialClinicalObservation;
export type TClinicalObservationICUDefaultValues =
  typeof initialClinicalObservationICU;
export type TGlucoseDefaultValues = typeof initialGlucose;
export type TIntakeOutputDefaultValues = typeof initialIntakeOutput;
export type TBedScoreDefaultValues = typeof initialBedScore;
export type TNeedsDefaultValues = typeof initialNeeds;
export type TFallDefaultValues = typeof initialFall;
export type TPediatric_fallDefaultValues = typeof initialPediatric_fall;
export type TGCSDefaultValues = typeof initialGCS;
export type TPediaTric_GCSDefaultValues = typeof initialPediatric_GCS;
export type TFourScoreDefaultValues = typeof initialFourScore;
export type TSafetyDefaultValues = typeof initialSafety;
export type TNRSDefaultValues = typeof initialNRS;
export type TFLACCDefaultValues = typeof initialFLACC;
export type TCNPSDefaultValues = typeof initialCNPS;
export type TFFIDefaultValues = typeof initialFFI;
export type TKOOSDefaultValues = typeof initialKOOS;
export type TLEFSDefaultValues = typeof initialLEFS;
export type TNDIDefaultValues = typeof initialNDI;
export type TSTarTBackScreeningDefaultValues = typeof initialSTarTBack;
export type TMentalNursingDefaultValues = typeof initialMentalNursing;
export type TBDIDefaultValues = typeof initialBDI;
export type TBAIDefaultValues = typeof initialBAI;
export type TMMSEDefaultValues = typeof initialMMSE;
export type TOperationDefaultValues = typeof initialOperation;
export type TAnesthesiaDefaultValues = typeof initialAnesthesia;
// Patient Guide => 수혈동의서
export type TTransfusionDefaultValues = typeof initialTransfusion;
// Patient Consent Form => 대장내시경으로
export type TColonoscopyDefaultValues = typeof initialColonoscopy;
export type TTransfusionAgreeDefaultValues = typeof initialPatientGuide;
// Conscious Sedation => 비급여동의서로
export type TNonSalaryDefaultValues = typeof initialNonSalary;
export type TDNRDefaultValues = typeof initialDNR;
// Admission Agreement=> 입원안내확인서
export type THospitalConfirmDefaultValues = typeof initialHospitalConfirm;
export type TAdmissionCheckListDefaultValues = typeof initialAdmissionCheckList;
export type TFallPreventionDefaultValues = typeof initialFallPrevention;
export type TCRRTDefaultValues = typeof initialCRRT;
export type TCentralVenousDefaultValues = typeof initialCentralVenous;
export type TIntubationAgreeDefaultValues = typeof initialIntubationAgree;
export type TSuppressorDefaultValues = typeof initialSuppressor;

export type TIntubationDefaultValues = typeof initialIntubation;
export type TCPRDefaultValues = typeof initialCPR;
export type TDialysisDefaultValues = typeof initialDialysis;
export type TEmergencyDefaultValues = typeof initialEmergency;
export type TChildbirthDefaultValues = typeof initialChildbirth;
export type THomeCareDefaultValues = typeof initialHomeCare;
export type TDietNutritionDefaultValues = typeof initialDietNutrition;
export type TTransfusionAgreementDefaultValues =
  typeof initialTransfusionAgreement;
export type TCoreNursingSkillVideoDefaultValues =
  typeof initialCoreNursingSkillVideo;
